// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__Kt2IL","close":"style_close__QMx8c","divider":"style_divider__d04xg"};